import {Component, inject} from '@angular/core';
import {FormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {TranslationService} from '../../../core/services/translation.service';
import {RevocationService} from '../../../data/services/revocation.service';
import {NavigationCommand} from '../../../data/services/navigation.service';
import {GeneralErrorsComponent} from '../../../core/components/general-errors/general-errors.component';
import {LoadingSpinnerComponent} from '../../../core/components/loading-spinner/loading-spinner.component';
import {MatCard, MatCardActions, MatCardContent} from '@angular/material/card';
import {MatButton} from '@angular/material/button';
import {MatError, MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {ApplyIfNotEmptyDirective} from '../../../core/directives/apply-if-not-empty.directive';
import {SnackbarService} from '../../../core/services/snackbar.service';
import {UnauthorizedRevocationRequest} from '../../../data/models/revocation.model';

@Component({
  selector: 'app-revocation-without-login',
  templateUrl: './revocation-without-login.component.html',
  styleUrls: ['./revocation-without-login.component.scss'],
  imports: [
    GeneralErrorsComponent,
    LoadingSpinnerComponent,
    ReactiveFormsModule,
    MatCard,
    MatCardContent,
    MatCardActions,
    MatButton,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    ApplyIfNotEmptyDirective
  ],
  standalone: true
})
export class RevocationWithoutLoginComponent {
  private formBuilder = inject(FormBuilder);
  private revocationService = inject(RevocationService);
  private router = inject(Router);
  translationService = inject(TranslationService);
  snackbarService = inject(SnackbarService);

  isLoading = false;
  errorsArr: string[] = [];

  identificationForm = this.formBuilder.nonNullable.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    orderNo: ['', Validators.required]
  });

  onSubmit(): void {
    if (this.identificationForm.invalid) {
      this.identificationForm.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    this.errorsArr = [];
    // idType UNKNOWN: ohne Login ist nicht bekannt, ob die Nummer aus der Web-DB oder aus Paradise kommt
    const formData: UnauthorizedRevocationRequest = {...this.identificationForm.getRawValue(), idType: 'UNKNOWN'};
    this.revocationService.sendUnauthorizedRevocation(formData).subscribe({
      next: () => {
        this.isLoading = false;
        this.snackbarService.openSnackbar(this.translationService.getTranslation('revocation_saved'));
        this.router.navigate([NavigationCommand.REVOCATIONWITHOUTLOGINAFTER], {state: {formData}});
      },
      error: () => {
        // Kein Feedback an den Nutzer ob Daten gefunden wurden – immer weiterleiten
        this.isLoading = false;
        this.router.navigate([NavigationCommand.REVOCATIONWITHOUTLOGINAFTER], {state: {formData}});
      }
    });
  }
}
